import MessageSolidSVG from "@design-system/ui-icons/vanilla/MessageSolid"
import { createIcon } from "../createIcon"

export const MessageSolidIcon = createIcon(MessageSolidSVG)
